/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Search_Where_PlaceholderInputs */

const en_directory_search_where_placeholder = /** @type {(inputs: Directory_Search_Where_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`City or near me`)
};

const pl_directory_search_where_placeholder = /** @type {(inputs: Directory_Search_Where_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miasto lub w pobliżu`)
};

/**
* | output |
* | --- |
* | "City or near me" |
*
* @param {Directory_Search_Where_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const directory_search_where_placeholder = /** @type {((inputs?: Directory_Search_Where_PlaceholderInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Search_Where_PlaceholderInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_directory_search_where_placeholder(inputs)
	return en_directory_search_where_placeholder(inputs)
});